import { render } from "./CollectionDialog.vue?vue&type=template&id=8782bdd6"
import script from "./CollectionDialog.vue?vue&type=script&lang=js"
export * from "./CollectionDialog.vue?vue&type=script&lang=js"

import "./CollectionDialog.vue?vue&type=style&index=0&id=8782bdd6&lang=scss"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__